var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpriteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-down",
    viewBox: "0 0 30 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.8235,
    d: "M7.529 12.235l7.529 7.529 7.529-7.529"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevron",
    viewBox: "0 0 46 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 6.8571,
    d: "M4.571 6.857l18.286 18.286 18.286-18.286"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2 5.12c-0.005-0-0.012-0-0.018-0-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.006 0 0.013-0 0.019-0h25.599c0.005 0 0.012 0 0.018 0 0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28c-0.006 0-0.013 0-0.019 0h-25.599zM3.2 14.72c-0.005-0-0.012-0-0.018-0-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.006 0 0.013-0 0.019-0h25.599c0.005 0 0.012 0 0.018 0 0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28c-0.006 0-0.013 0-0.019 0h-25.599zM3.2 24.32c-0.005-0-0.012-0-0.018-0-0.707 0-1.28 0.573-1.28 1.28s0.573 1.28 1.28 1.28c0.006 0 0.013-0 0.019-0h25.599c0.005 0 0.012 0 0.018 0 0.707 0 1.28-0.573 1.28-1.28s-0.573-1.28-1.28-1.28c-0.006 0-0.013 0-0.019 0h-25.599z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M4 16h24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M4 24h24"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "hexagon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M14.964 3.242c0.378-0.21 0.567-0.315 0.767-0.356 0.177-0.036 0.36-0.036 0.537 0 0.2 0.041 0.389 0.146 0.767 0.356l9.867 5.481c0.399 0.222 0.599 0.333 0.744 0.491 0.129 0.14 0.226 0.305 0.285 0.485 0.067 0.204 0.067 0.432 0.067 0.889v10.823c0 0.457 0 0.685-0.067 0.889-0.060 0.18-0.157 0.346-0.285 0.485-0.145 0.158-0.345 0.269-0.744 0.491l-9.867 5.481c-0.378 0.21-0.567 0.315-0.767 0.356-0.177 0.036-0.36 0.036-0.537 0-0.2-0.041-0.389-0.146-0.767-0.356l-9.867-5.481c-0.399-0.222-0.599-0.333-0.744-0.491-0.129-0.14-0.226-0.305-0.286-0.485-0.067-0.204-0.067-0.432-0.067-0.889v-10.823c0-0.457 0-0.685 0.067-0.889 0.060-0.18 0.157-0.346 0.286-0.485 0.145-0.158 0.345-0.269 0.744-0.491l9.867-5.481z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "colors",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M16 27.296c1.415 1.267 3.284 2.037 5.333 2.037 4.418 0 8-3.582 8-8 0-3.689-2.497-6.795-5.893-7.72M8.56 13.614c-3.396 0.925-5.894 4.031-5.894 7.72 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.041-0.199-2.035-0.56-2.947M24 10.667c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8c4.418 0 8 3.582 8 8z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.6667,
    d: "M18.999 2.667h-7.674c-0.239 0-0.359 0-0.465 0.036-0.093 0.032-0.178 0.085-0.249 0.154-0.080 0.078-0.133 0.185-0.24 0.399l-5.6 11.2c-0.256 0.511-0.383 0.767-0.353 0.974 0.027 0.181 0.127 0.344 0.277 0.449 0.172 0.12 0.458 0.12 1.029 0.12h8.274l-4 13.333 16.258-16.86c0.548-0.569 0.823-0.853 0.839-1.097 0.014-0.211-0.073-0.417-0.235-0.553-0.186-0.157-0.581-0.157-1.372-0.157h-9.49l3-8z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "container",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M27.333 9.704l-11.333 6.296M16 16l-11.333-6.296M16 16l0 12.667M28 21.411v-10.823c0-0.457 0-0.685-0.067-0.889-0.060-0.18-0.157-0.346-0.285-0.485-0.145-0.158-0.345-0.269-0.744-0.491l-9.867-5.481c-0.378-0.21-0.567-0.315-0.767-0.356-0.177-0.036-0.36-0.036-0.537 0-0.2 0.041-0.389 0.146-0.767 0.356l-9.867 5.481c-0.399 0.222-0.599 0.333-0.744 0.491-0.129 0.14-0.226 0.305-0.286 0.485-0.067 0.204-0.067 0.432-0.067 0.889v10.823c0 0.457 0 0.685 0.067 0.889 0.060 0.18 0.157 0.346 0.286 0.485 0.145 0.158 0.345 0.269 0.744 0.491l9.867 5.481c0.378 0.21 0.567 0.315 0.767 0.356 0.177 0.036 0.36 0.036 0.537 0 0.2-0.041 0.389-0.146 0.767-0.356l9.867-5.481c0.399-0.222 0.599-0.333 0.744-0.491 0.129-0.14 0.226-0.305 0.285-0.485 0.067-0.204 0.067-0.432 0.067-0.889z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "puzzle-piece",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M16 2.667l4.8 4.8c3.2-8.4 12.133 0.533 3.733 3.733l4.8 4.8-4.8 4.8c-3.2-8.4-12.133 0.533-3.733 3.733l-4.8 4.8-4.8-4.8c-3.2 8.4-12.133-0.533-3.733-3.733l-4.8-4.8 4.8-4.8c3.2 8.4 12.133-0.533 3.733-3.733l4.8-4.8z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "loading",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M4.454 22.666c-1.67-2.893-0.821-6.58 1.944-8.453l0.003-0.003c2.221-1.501 5.143-1.45 7.312 0.126l4.576 3.327c2.167 1.576 5.090 1.627 7.312 0.126l0.003-0.003c2.766-1.872 3.616-5.563 1.943-8.453M22.669 27.546c-2.893 1.669-6.58 0.821-8.453-1.944l-0.003-0.003c-1.501-2.221-1.45-5.143 0.126-7.312l3.327-4.576c1.576-2.167 1.627-5.090 0.126-7.312l-0.006-0.003c-1.872-2.763-5.563-3.615-8.453-1.942M25.427 6.572c5.207 5.207 5.207 13.648 0 18.855s-13.648 5.207-18.855 0c-5.207-5.207-5.207-13.648 0-18.855s13.648-5.207 18.855 0z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M16 2.667l2.683 6.975c0.376 0.978 0.564 1.466 0.856 1.878 0.259 0.364 0.577 0.683 0.942 0.942 0.411 0.292 0.9 0.48 1.878 0.856l6.975 2.683-6.975 2.683c-0.978 0.376-1.466 0.564-1.878 0.856-0.364 0.259-0.683 0.577-0.942 0.942-0.292 0.411-0.48 0.9-0.856 1.878l-2.683 6.975-2.683-6.975c-0.376-0.978-0.564-1.466-0.856-1.878-0.259-0.364-0.578-0.683-0.942-0.942-0.411-0.292-0.9-0.48-1.878-0.856l-6.975-2.683 6.975-2.683c0.978-0.376 1.466-0.564 1.878-0.856 0.364-0.259 0.683-0.578 0.942-0.942 0.292-0.411 0.48-0.9 0.856-1.878l2.683-6.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M16 2.667l2.683 6.975c0.376 0.978 0.564 1.466 0.856 1.878 0.259 0.364 0.577 0.683 0.942 0.942 0.411 0.292 0.9 0.48 1.878 0.856l6.975 2.683-6.975 2.683c-0.978 0.376-1.466 0.564-1.878 0.856-0.364 0.259-0.683 0.577-0.942 0.942-0.292 0.411-0.48 0.9-0.856 1.878l-2.683 6.975-2.683-6.975c-0.376-0.978-0.564-1.466-0.856-1.878-0.259-0.364-0.578-0.683-0.942-0.942-0.411-0.292-0.9-0.48-1.878-0.856l-6.975-2.683 6.975-2.683c0.978-0.376 1.466-0.564 1.878-0.856 0.364-0.259 0.683-0.578 0.942-0.942 0.292-0.411 0.48-0.9 0.856-1.878l2.683-6.975z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "project",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M4.396 6.978c0.301-1.281 1.301-2.282 2.582-2.582v0c1.11-0.26 2.266-0.26 3.377 0v0c1.281 0.301 2.282 1.301 2.582 2.582v0c0.26 1.11 0.26 2.266 0 3.377v0c-0.301 1.281-1.301 2.282-2.582 2.582v0c-1.11 0.26-2.266 0.26-3.377 0v0c-1.281-0.301-2.282-1.301-2.582-2.582v0c-0.26-1.11-0.26-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M4.396 21.645c0.301-1.281 1.301-2.282 2.582-2.582v0c1.11-0.261 2.266-0.261 3.377 0v0c1.281 0.3 2.282 1.301 2.582 2.582v0c0.26 1.111 0.26 2.266 0 3.377v0c-0.301 1.281-1.301 2.282-2.582 2.582v0c-1.11 0.261-2.266 0.261-3.377 0v0c-1.281-0.3-2.282-1.301-2.582-2.582v0c-0.26-1.111-0.26-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M19.063 6.978c0.3-1.281 1.301-2.282 2.582-2.582v0c1.111-0.26 2.266-0.26 3.377 0v0c1.281 0.301 2.282 1.301 2.582 2.582v0c0.261 1.11 0.261 2.266 0 3.377v0c-0.3 1.281-1.301 2.282-2.582 2.582v0c-1.111 0.26-2.266 0.26-3.377 0v0c-1.281-0.301-2.282-1.301-2.582-2.582v0c-0.261-1.11-0.261-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6667,
    d: "M19.063 21.645c0.3-1.281 1.301-2.282 2.582-2.582v0c1.111-0.261 2.266-0.261 3.377 0v0c1.281 0.3 2.282 1.301 2.582 2.582v0c0.261 1.111 0.261 2.266 0 3.377v0c-0.3 1.281-1.301 2.282-2.582 2.582v0c-1.111 0.261-2.266 0.261-3.377 0v0c-1.281-0.3-2.282-1.301-2.582-2.582v0c-0.261-1.111-0.261-2.266 0-3.377v0z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    d: "M12 4h8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    d: "M6.667 8l0.801 12.018c0.149 2.231 0.223 3.347 0.588 4.243 0.662 1.627 2.004 2.883 3.672 3.435 0.919 0.304 2.037 0.304 4.273 0.304v0c2.236 0 3.354 0 4.273-0.304 1.668-0.552 3.010-1.808 3.672-3.435 0.365-0.896 0.439-2.012 0.588-4.243l0.801-12.018"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    style: {
      fill: "var(--icon-logo-background-color, #161616)"
    },
    d: "M25.6 0h-19.2c-3.535 0-6.4 2.865-6.4 6.4v0 19.2c0 3.535 2.865 6.4 6.4 6.4v0h19.2c3.535 0 6.4-2.865 6.4-6.4v0-19.2c0-3.535-2.865-6.4-6.4-6.4v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--icon-logo-color, #fff)"
    },
    d: "M13.331 23.027c0.245-1.272 0.453-2.61 0.747-3.949 0.144-0.701-0.032-1-0.815-0.946s-1.656 0.027-2.49 0c-0.832-0.026-0.982-0.446-0.502-1.044 2.363-2.918 4.753-5.8 7.134-8.674 0.266-0.326 0.574-0.558 1.014-0.312s0.349 0.549 0.276 0.914c-0.262 1.338-0.48 2.678-0.77 3.989-0.149 0.678 0.046 0.92 0.752 0.893 0.318-0.017 0.689-0.027 1.064-0.027s0.746 0.010 1.115 0.029l-0.052-0.002c0.402 0 0.933-0.21 1.141 0.339s-0.231 0.781-0.453 1.106c-1.328 1.643-2.228 2.73-3.136 3.811l0.384-0.47c-1.361 1.624-2.712 3.242-4.051 4.854-0.262 0.317-0.557 0.571-1.005 0.41s-0.354-0.54-0.354-0.923z"
  })), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "broken-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6,
    d: "M4.45 9.333c2.305-3.985 6.614-6.667 11.55-6.667 7.364 0 13.333 5.97 13.333 13.333s-5.97 13.333-13.333 13.333c-4.935 0-9.244-2.681-11.55-6.667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6,
    d: "M16 21.333l5.333-5.333-5.333-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.6,
    d: "M2.667 16h18.667"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-avatar",
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.445 7.556c0 4.173-3.383 7.556-7.556 7.556s-7.556-3.383-7.556-7.556c0-4.173 3.383-7.556 7.556-7.556s7.556 3.383 7.556 7.556z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.169 33.208c0-2.441-0.481-4.857-1.415-7.112s-2.303-4.303-4.029-6.029c-1.726-1.726-3.774-3.095-6.029-4.029s-4.671-1.415-7.112-1.415c-2.44 0-4.857 0.481-7.112 1.415s-4.303 2.303-6.029 4.029c-1.726 1.726-3.095 3.774-4.029 6.029s-1.415 4.671-1.415 7.112h37.169z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-ico",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f1f",
    style: {
      fill: "var(--color1, #1f1f1f)"
    },
    d: "M3.765 0h24.471c2.079 0 3.765 1.686 3.765 3.765v24.471c0 2.079-1.686 3.765-3.765 3.765h-24.471c-2.079 0-3.765-1.686-3.765-3.765v-24.471c0-2.079 1.686-3.765 3.765-3.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    style: {
      fill: "var(--color2, #151515)"
    },
    d: "M21.49 14.745c0 2.945-2.388 5.333-5.333 5.333s-5.333-2.388-5.333-5.333c0-2.945 2.388-5.333 5.333-5.333s5.333 2.388 5.333 5.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    style: {
      fill: "var(--color2, #151515)"
    },
    d: "M29.060 32.853c0-7.245-5.873-13.118-13.118-13.118s-13.118 5.873-13.118 13.118v0h26.237z"
  })), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 3,
    d: "M12.472 28c0.94 0.83 2.175 1.333 3.528 1.333s2.588-0.504 3.528-1.333M24 10.667c0-2.122-0.843-4.157-2.343-5.657s-3.535-2.343-5.657-2.343-4.157 0.843-5.657 2.343c-1.5 1.5-2.343 3.535-2.343 5.657 0 4.12-1.039 6.941-2.2 8.807-0.979 1.574-1.469 2.361-1.451 2.58 0.020 0.243 0.071 0.336 0.267 0.481 0.177 0.131 0.974 0.131 2.569 0.131h17.63c1.595 0 2.392 0 2.569-0.131 0.196-0.145 0.247-0.238 0.267-0.481 0.018-0.22-0.472-1.006-1.451-2.58-1.161-1.866-2.2-4.687-2.2-8.807z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "filter",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M29.334 4h-26.667l10.667 12.613v8.72l5.333 2.667v-11.387l10.667-12.613z",
    strokeWidth: 1.7
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "log-out",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.5,
    d: "M11.867 10.080c0.413-4.8 2.88-6.76 8.28-6.76h0.173c5.96 0 8.347 2.387 8.347 8.347v8.693c0 5.96-2.387 8.347-8.347 8.347h-0.173c-5.36 0-7.827-1.933-8.267-6.653"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.5,
    d: "M2.667 16h17.173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.5,
    d: "M16.867 11.533l4.467 4.467-4.467 4.467"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "radio-button-unchecked",
    viewBox: "0 0 32 32",
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "radio-button-checked",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 4,
    fill: "#8FA1D0",
    style: {
      fill: "var(--radio-inside, #8FA1D0)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "#8FA1D0",
    style: {
      stroke: "var(--radio-outside, #8FA1D0)"
    }
  })), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.5 4.5-9 9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 4.5 9 9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m1.666 14.333 3.7-1.423c.237-.09.355-.136.466-.195.098-.053.192-.114.28-.183.1-.077.189-.166.368-.345L14 4.666A1.886 1.886 0 0 0 11.333 2l-7.52 7.52a4.16 4.16 0 0 0-.346.368 2 2 0 0 0-.182.28c-.06.11-.105.23-.196.466l-1.423 3.7zm0 0 1.373-3.567c.097-.255.146-.383.23-.441a.333.333 0 0 1 .253-.054c.1.02.197.117.39.31l1.507 1.506c.193.194.29.29.309.391a.333.333 0 0 1-.055.253c-.058.084-.186.133-.441.231l-3.568 1.373z",
    strokeWidth: 1
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 3,
    d: "M16 6.667v18.667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 3,
    d: "M6.666 16h18.667"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 12h-11v-11c0-0.552-0.448-1-1-1h-6c-0.552 0-1 0.448-1 1v11h-11c-0.552 0-1 0.448-1 1v6c0 0.552 0.448 1 1 1h11v11c0 0.552 0.448 1 1 1h6c0.552 0 1-0.448 1-1v-11h11c0.552 0 1-0.448 1-1v-6c0-0.552-0.448-1-1-1z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 28 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f1f",
    style: {
      fill: "var(--color1, #1f1f1f)"
    },
    d: "M3.282 0h21.333c1.813 0 3.282 1.469 3.282 3.282v21.333c0 1.813-1.469 3.282-3.282 3.282h-21.333c-1.813 0-3.282-1.469-3.282-3.282v-21.333c0-1.813 1.469-3.282 3.282-3.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    style: {
      fill: "var(--color2, #151515)"
    },
    d: "M18.735 12.855c0 2.568-2.082 4.65-4.65 4.65s-4.65-2.082-4.65-4.65c0-2.568 2.082-4.65 4.65-4.65s4.65 2.082 4.65 4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    style: {
      fill: "var(--color2, #151515)"
    },
    d: "M25.335 28.641c0-1.502-0.296-2.989-0.871-4.377s-1.417-2.648-2.479-3.71c-1.062-1.062-2.323-1.904-3.71-2.479s-2.875-0.871-4.377-0.871c-1.502 0-2.989 0.296-4.377 0.871s-2.648 1.417-3.71 2.479c-1.062 1.062-1.904 2.323-2.479 3.71s-0.871 2.875-0.871 4.377h22.873z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bedbb0",
    style: {
      fill: "var(--color3, #bedbb0)"
    },
    d: "M16.41 22.154h-4.923c-1.359 0-2.462 1.102-2.462 2.462v4.923c0 1.359 1.102 2.462 2.462 2.462h4.923c1.359 0 2.462-1.102 2.462-2.462v-4.923c0-1.359-1.102-2.462-2.462-2.462z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#161616",
    style: {
      stroke: "var(--color4, #161616)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 0.4103,
    d: "M13.949 25.88v2.393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#161616",
    style: {
      stroke: "var(--color4, #161616)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 0.4103,
    d: "M12.752 27.077h2.393"
  })), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 9s3-6 8.25-6 8.25 6 8.25 6-3 6-8.25 6S.75 9 .75 9z",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5z",
    strokeWidth: 1.3
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "help_circle",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.333A8.333 8.333 0 1 0 10 1.667a8.333 8.333 0 0 0 0 16.666z",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.575 7.5a2.5 2.5 0 0 1 4.859.833c0 1.667-2.5 2.5-2.5 2.5",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.167h.012",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "no-background",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6664 14H13.34C13.9875 14 14.3112 14 14.4896 13.865C14.6451 13.7474 14.7413 13.5677 14.7529 13.3731C14.7662 13.1497 14.5867 12.8804 14.2275 12.3417L12.2206 9.33128C11.9239 8.88616 11.7755 8.66359 11.5885 8.58604C11.425 8.51823 11.2412 8.51823 11.0777 8.58604C10.8907 8.66359 10.7423 8.88616 10.4456 9.33128L9.94945 10.0755M12.6664 14L7.54344 6.60012C7.24881 6.17455 7.1015 5.96176 6.91748 5.88696C6.75651 5.82152 6.57635 5.82152 6.41538 5.88696C6.23137 5.96176 6.08405 6.17455 5.78943 6.60012L1.82523 12.3262C1.44988 12.8684 1.26221 13.1394 1.27289 13.3649C1.2822 13.5612 1.37768 13.7435 1.53382 13.8629C1.7131 14 2.04281 14 2.70224 14H12.6664ZM13.9998 4C13.9998 5.10457 13.1043 6 11.9998 6C10.8952 6 9.99976 5.10457 9.99976 4C9.99976 2.89543 10.8952 2 11.9998 2C13.1043 2 13.9998 2.89543 13.9998 4Z",
    stroke: "#161616",
    strokeOpacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M16 6.667v18.665M6.667 16h18.665"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-off",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.504 6.952c0.868-0.203 1.728-0.295 2.48-0.285 2.344 0 4.412 0.745 6.211 1.857 1.492 0.923 2.785 2.089 3.859 3.264 0.859 0.94 1.567 1.873 2.113 2.668 0.436 0.633 0.76 1.165 0.977 1.54-0.728 1.271-1.547 2.428-2.371 3.389-0.479 0.559-0.415 1.401 0.144 1.88s1.401 0.415 1.88-0.144c1.091-1.272 2.148-2.816 3.044-4.493 0.197-0.372 0.217-0.824 0.017-1.225 0 0-0.528-1.052-1.493-2.457-0.601-0.875-1.384-1.909-2.343-2.957-1.192-1.305-2.672-2.649-4.425-3.733-2.127-1.313-4.675-2.255-7.581-2.255-0.979-0.012-2.053 0.105-3.12 0.355-0.717 0.168-1.163 0.885-0.995 1.603s0.885 1.163 1.603 0.995zM13.369 15.256l3.375 3.375c-0.243 0.081-0.496 0.125-0.751 0.135-0.684 0.024-1.373-0.212-1.912-0.715s-0.823-1.173-0.847-1.857c-0.011-0.317 0.033-0.635 0.135-0.939zM7.977 9.863l3.404 3.404c-0.579 0.921-0.848 1.979-0.811 3.021 0.048 1.363 0.617 2.711 1.695 3.713s2.461 1.476 3.824 1.428c0.923-0.032 1.839-0.304 2.645-0.811l3.096 3.096c-1.837 1.065-3.86 1.595-5.845 1.619-2.312 0-4.38-0.745-6.179-1.857-1.492-0.923-2.785-2.089-3.859-3.264-0.859-0.94-1.567-1.873-2.113-2.668-0.435-0.633-0.76-1.164-0.976-1.539 1.4-2.429 3.168-4.505 5.121-6.143zM0.391 2.276l5.695 5.695c-2.308 1.972-4.359 4.477-5.927 7.399-0.197 0.372-0.219 0.825-0.017 1.227 0 0 0.528 1.052 1.493 2.457 0.601 0.875 1.384 1.909 2.343 2.957 1.192 1.305 2.672 2.649 4.425 3.733 2.127 1.315 4.675 2.256 7.613 2.256 2.657-0.032 5.359-0.801 7.753-2.345l5.955 5.955c0.521 0.521 1.365 0.521 1.885 0s0.521-1.365 0-1.885l-11.835-11.835c-0.003-0.003-0.007-0.007-0.009-0.009l-5.612-5.613c-0.011-0.009-0.021-0.021-0.032-0.032l-11.845-11.844c-0.521-0.521-1.365-0.521-1.885 0s-0.521 1.365 0 1.885z",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpriteIcon);
export default __webpack_public_path__ + "static/media/sprite-icon.f5eca9643725bb0ee354a19beabd5c5c.svg";
export { ForwardRef as ReactComponent };